export default __webpack_public_path__ + "static/1406-2d38dbc2d5a459a7bcdae75d4b0212e4.gif";